import axios from 'axios';

const separateAxiosInstance = axios.create();

export default separateAxiosInstance;
